export default __webpack_public_path__ + "static/media/29994-adam-and-eve-in-the-garden-of-eden.800w.tn.5f1ee338.jpg";